// Tiny fetch wrapper. Reads JWT from localStorage, attaches Authorization
// header, parses JSON, throws on non-2xx with the server's error message.
//
// Same shape as WenMail's frontend api helper so cloning patterns is easy.

const TOKEN_KEY = "notify-token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (init.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }

  const res = await fetch(path.startsWith("/") ? path : "/" + path, { ...init, headers });
  const isJson = res.headers.get("content-type")?.includes("application/json");
  const body = isJson ? await res.json().catch(() => null) : await res.text();

  if (!res.ok) {
    const msg = (isJson && (body as { message?: string } | null)?.message) || `HTTP ${res.status}`;
    if (res.status === 401) clearToken();
    throw new ApiError(res.status, msg, body);
  }
  return body as T;
}
